import React, { useState, useEffect, useRef } from "react";
import { KeywordsWordCloud, KeywordsWordCloud_cloud } from "../data/dummy";
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";

const KeywordFrequencyTable = ({ keywordColors, onColorChange, intent, sentiment }) => {
  const [keywords, setKeywords] = useState(KeywordsWordCloud_cloud);
  const [showPalette, setShowPalette] = useState(null);
  const paletteRef = useRef();

  // const [intent, setIntent] = useState(location.state?.intentName || "");
  // const [sentiment, setSentiment] = useState(location.state?.sentiment || "");

  console.log(`intent : ${intent}, sentiment : ${sentiment}`);
  // 팔레트 닫기 핸들러
  const closePalette = () => setShowPalette(null);

  // ESC 키 또는 외부 클릭 감지
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closePalette(); // ESC 키로 닫기
    };

    const handleClickOutside = (e) => {
      if (paletteRef.current && !paletteRef.current.contains(e.target)) {
        closePalette(); // 외부 클릭 시 닫기
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 랜덤 색상 생성 함수
  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // 랜덤 색상 변경 핸들러
  const handleRandomColor = () => {
    const randomColors = {};
    keywords.forEach((item) => {
      randomColors[item.text] = getRandomColor(); // 각 키워드에 랜덤 색상 할당
    });
    Object.entries(randomColors).forEach(([text, color]) => {
      onColorChange(text, color); // 상위 컴포넌트에 전달
    });
  };

  // 팔레트 표시 및 색상 변경
  const handleColorChange = (args, text) => {
    const chosenColor = args.currentValue.hex; // 선택된 색상
    onColorChange(text, chosenColor); // 상위 컴포넌트에 전달
    closePalette(); // 팔레트 닫기
  };

  return (
    <div>
      <table border="1" cellPadding="5" cellSpacing="0">
        <thead>
          <tr>
            <th>Id</th>
            <th>키워드</th>
            <th>카운트</th>
            <th>컬러</th>
            <th>제거</th>
          </tr>
        </thead>
        <tbody>
          {keywords[intent][sentiment].map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td style={{ color: "black" }}>
                {item.text}
              </td>
              <td>{item.value}</td>
              <td>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    setShowPalette((prev) =>
                      prev === item.text ? null : item.text
                    );
                  }}
                  style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                >
                  변경
                </button>
                {showPalette === item.text && (
                  <div
                    ref={paletteRef} // 팔레트 참조 추가
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      background: "#fff",
                      border: "1px solid #ccc",
                      padding: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      marginTop: "5px",
                    }}
                  >
                    <ColorPickerComponent
                      mode="Palette"
                      modeSwitcher={false}
                      inline
                      showButtons={false}
                      change={(args) => handleColorChange(args, item.text)} // 색상 변경
                    />
                  </div>
                )}
              </td>
              <td>
                <button
                  onClick={() =>
                    setKeywords(keywords.filter((k) => k.text !== item.text))
                  }
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                >
                  제거
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default KeywordFrequencyTable;
